import SelectPlatform from './SelectPlatform';

export default SelectPlatform;
